import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoadingComponent } from '@scandium-oy/ngx-scandium';
import { filter, shareReplay, switchMap } from 'rxjs';
import { AppCommonModule } from 'src/app/common.module';
import { DashboardViewComponent } from 'src/app/components/views/dashboard/view-dashboard.component';
import { PartnerNote } from 'src/app/models/partner-note.model';
import { TimestampPipe } from 'src/app/pipes/timestamp/timestamp.pipe';
import { PartnerNotesService } from 'src/app/services/partner-notes.service';
import { PlusService } from 'src/app/services/plus.service';
import { UserSessionService } from 'src/app/services/user-session.service';
import { Roles } from 'src/app/utility/role';
import { PartnerNoteDialogComponent } from './dialog/partner-note.dialog';

@Component({
  selector: 'app-partner-notes-page',
  templateUrl: './partner-notes.page.html',
  styleUrls: ['./partner-notes.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    CommonModule,
    LoadingComponent,
    DashboardViewComponent,
    TimestampPipe,
  ],
})
export class PartnerNotesPage {

  items$ = this.usersService.getCurrentUser().pipe(
    filter((user) => user != null),
    switchMap((user) => this.service.getList({ user: user.guid })),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private modalCtrl: ModalController,
    private plusService: PlusService,
    private service: PartnerNotesService,
    private usersService: UserSessionService,
  ) { }

  onNewNote() {
    this.plusService.onNewPartnerNote();
  }

  onItem(item: PartnerNote) {
    this.modalCtrl.create({ component: PartnerNoteDialogComponent, componentProps: { item } }).then((m) => {
      m.present();
      m.onDidDismiss<PartnerNote>().then((data) => {
        if (data.data) {
          const updated = Object.assign({}, item, data.data);
          const user = this.usersService.currentUserS();
          if (user.role === Roles.partner && !this.usersService.isPremiumPartner(user) && updated.inviter !== user.guid) {
            updated.inviter = user.guid;
          }
          this.service.update(updated);
        }
      });
    });
  }
}
